import { EuroRounded, PercentRounded } from "@mui/icons-material";
import { TextField } from '@mui/material'
import InputAdornment from "@mui/material/InputAdornment";

export const textFieldDefaults = {
	fullWidth: true,
	variant: 'standard'
}

export const textFieldSelectDefaults = {
	...textFieldDefaults,
	select: true
}

export const numericFormatInputProps = {
	min: 0,
	style: { textAlign: 'right' }
}

export const numericFormatInputDefaults = {
	customInput: TextField,
	slotProps: {
		htmlInput: {...numericFormatInputProps}
	}
}

export const numericFormatDigitDefaults = {
	decimalScale: 2,
	allowLeadingZeros: false,
	allowNegative: false
}

export const numericFormatDefaults = {
	...textFieldDefaults,
	...numericFormatDigitDefaults,
	...numericFormatInputDefaults
}

export const numericFormatWithIconProps = (IconComponent) => {
	return {
		...numericFormatDefaults,
		slotProps: {
			htmlInput: {
				...numericFormatInputProps
			},
			input: {
				endAdornment: (
					<InputAdornment position="end">
						<IconComponent fontSize={'small'}/>
					</InputAdornment>
				)
			}
		}
	}
}

export const formControlDefaults = {
	sx: { width: '100%' }
}